import styled from 'styled-components';

export const RankingSelect = styled.div.attrs({
    className: 'styled-ranking-select',
})`
    .component-page-container {
        text-align: center;
    }

    .c-page-image {
        margin-top: 2.2rem;
    }

    .c-page-title {
        font-size: 2.2rem;
    }
    .c-page-descr {
        font-size: 1.6rem;
        font-weight: 500;
        margin-top: 1rem;
    }
    .c-page-texts {
        margin-top: 3rem;
    }

    .list-vertical-item-link {
        border-color: rgba(68, 68, 68, 0.2);
        color: #444;
    }
    .list-vertical-item-link .icon {
        font-size: 1.8rem;
    }
`;

export const CountryBtn = styled.button.attrs({
    classname: 'country-button',
})`
    border: none;
    display: block;

    padding: 10px 20px;
    margin-bottom: 1.6rem;
    border-radius: 35px;
    background: var(--primary);
    color: white;
    font-weight: 600;

    :focus {
        outline: none;
    }
`;

export const RankingContainer = styled.div.attrs({
    classname: 'ranking-container',
})`
    width: 100%;
    margin-top: 4.8rem;

    display: flex;
    justify-content: center;

    div:first-child {
        margin-right: 4.8rem;
    }

    @media (max-width: 900px) {
        flex-direction: column;
        align-items: center;

        div:first-child {
            margin-right: 0;
        }
    }
`;

export const CardContainer = styled.div.attrs({
    classname: 'card-container',
})`
    width: 85%;
    max-width: 30rem;
    /* background: #f2f2f2; */
    background: #fff;
    margin-bottom: 4.8rem;
    box-shadow: -2px 2px 8px rgba(0, 0, 0, 0.25);
    cursor: pointer;

    display: flex;
    flex-direction: column;
    align-items: center;
`;

export const Flag = styled.img.attrs({
    classname: 'flag',
})`
    border-radius: 50%;
    width: 5rem;
    height: 5.2rem;
    margin: -1rem 0 1rem 0;
`;

export const RankingText = styled.p.attrs({
    classname: 'ranking-text',
})`
    font-size: 1.8rem;
    font-weight: 700;
`;
